import React from 'react';
import { string, object, bool } from 'prop-types';
import { connect } from 'react-redux';
import get from 'lodash/get';

import StockTickrWrapper from './stock-ticker';

const MarketTicker = ({ pageType, section, marketTicker }) => {
  if (marketTicker) {
    return (
      <StockTickrWrapper
        pageType={pageType}
        sectionName={get(section, 'name')}
        sectionSlug={get(section, 'slug')}
      />
    );
  }

  return null;
};

MarketTicker.propTypes = {
  pageType: string,
  section: object,
  marketTicker: bool
};

const mapStateToProps = state => ({
  pageType: get(state, ['qt', 'pageType']),
  section: get(state, ['qt', 'data', 'section'], {}),
  marketTicker: get(state, ['qt', 'config', 'features', 'market_ticker', 'enabled'], false)
});

export default connect(mapStateToProps, null)(MarketTicker);
